import { bigCommerceFetch } from "."

import { BKDFToBigCommerceSorting, bigCommerceToBKDFProduct, bigCommerceToBKDFProducts } from "./mapper"
import {
    getFeaturedProductsQuery,
    getNewestProductsQuery,
    getPopularProductsQuery,
    getProductByPathQuery,
    getProductQuery,
    getProductsByCategoryQuery,
    getProductsRecommedationsQuery,
    getStoreProductsQuery,
    searchProductsQuery,
} from "./queries/product"

export async function getProducts({
    query,
    reverse,
    sortKey,
}: {
    query?: string
    reverse?: boolean
    sortKey?: string
}): Promise<BKDFProduct[]> {
    const sort = BKDFToBigCommerceSorting(reverse ?? false, sortKey)
    const res = await bigCommerceFetch<BigCommerceSearchProductsOperation>({
        query: searchProductsQuery,
        variables: {
            filters: {
                searchTerm: query || "",
            },
            sort,
        },
    })

    const productList = res.body.data.site.search.searchProducts.products.edges.map((item) => item.node)

    return bigCommerceToBKDFProducts(productList)
}

export async function getProductsByIds(ids: string[]): Promise<BKDFProduct[]> {
    const res = await bigCommerceFetch<BigCommerceProductsOperation>({
        query: getStoreProductsQuery,
        variables: {
            entityIds: ids.map((id) => parseInt(id, 10)),
        },
    })

    return bigCommerceToBKDFProducts(res.body.data.site.products.edges.map((item) => item.node))
}

export async function getProduct(id: string): Promise<BKDFProduct | undefined> {
    const res = await bigCommerceFetch<BigCommerceProductOperation>({
        query: getProductQuery,
        variables: {
            productId: parseInt(id, 10),
        },
    })

    return bigCommerceToBKDFProduct(res.body.data.site.product)
}

export async function getProductByHandle(handle: string): Promise<BKDFProduct | undefined> {
    const res = await bigCommerceFetch<BigCommerceProductByHandleOperation>({
        query: getProductByPathQuery,
        variables: {
            path: `/${handle}`,
        },
    })

    return bigCommerceToBKDFProduct(res.body.data.site.route.node)
}

export async function getProductsByCategory(categoryId: number): Promise<BKDFProduct[]> {
    const res = await bigCommerceFetch<BigCommerceProductsCategoryOperation>({
        query: getProductsByCategoryQuery,
        variables: {
            entityId: categoryId,
            sortBy: "BEST_SELLING",
            hideOutOfStock: false,
            first: 20,
        },
    })
    const productList = res.body.data.site.category.products.edges.map((item) => item.node)
    return bigCommerceToBKDFProducts(productList)
}

export async function getProductRecommendations(productId: string): Promise<BKDFProduct[]> {
    const res = await bigCommerceFetch<BigCommerceRecommendationsOperation>({
        query: getProductsRecommedationsQuery,
        variables: {
            productId: productId,
        },
    })

    const productList = res.body.data.site.product.relatedProducts.edges.map((item) => item.node)

    return bigCommerceToBKDFProducts(productList)
}

export async function getBestsellingProducts(): Promise<BKDFProduct[]> {
    const res = await bigCommerceFetch<BigCommercePopularProductsOperation>({
        query: getPopularProductsQuery,
    })

    return bigCommerceToBKDFProducts(res.body.data.site.bestSellingProducts.edges.map((item) => item.node))
}

export async function getNewestProducts(): Promise<BKDFProduct[]> {
    const res = await bigCommerceFetch<BigCommerceNewestProductsOperation>({
        query: getNewestProductsQuery,
    })

    return bigCommerceToBKDFProducts(res.body.data.site.newestProducts.edges.map((item) => item.node))
}

export async function getFeaturedProducts(): Promise<BKDFProduct[]> {
    const res = await bigCommerceFetch<BigCommerceFeaturedProductsOperation>({
        query: getFeaturedProductsQuery,
        variables: {},
    })

    return bigCommerceToBKDFProducts(res.body.data.site.featuredProducts.edges.map((item) => item.node))
}
